import { render, staticRenderFns } from "./ShareMakeMoney.vue?vue&type=template&id=b0627184&scoped=true&"
import script from "./ShareMakeMoney.vue?vue&type=script&lang=js&"
export * from "./ShareMakeMoney.vue?vue&type=script&lang=js&"
import style0 from "./ShareMakeMoney.vue?vue&type=style&index=0&id=b0627184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0627184",
  null
  
)

export default component.exports